import {getRefinementCutOffThreshold} from '../../../../../../helper';
import showMoreSection from './show-more-section';
import widthRefinementOption from './width-refinement-option';

/**
 * @param {import('../../../../../../type-definitions').Refinement} refinement - refinement
 * @param {import('../../../../../../interface/refinement-url-builder').default} refinementURLBuilder - url builder
 * @param {Object} seoUrlConfig - SEO exclude configuration
 * @returns {string} width refinement HTML
 */
export default (refinement, refinementURLBuilder, seoUrlConfig) => {
    if (!refinement || !refinement.options) {
        return '';
    }
    const cutOffThreshold = getRefinementCutOffThreshold(refinement.baseID);
    const visibleRefinementItems = [];
    const cutOffRefinements = [];
    for (let i = 0, len = refinement.options.length; i < len; i++) {
        const option = refinement.options[i];
        const refinementHTML = widthRefinementOption(refinement, option, refinementURLBuilder, seoUrlConfig);
        if (i < cutOffThreshold) {
            visibleRefinementItems.push(refinementHTML);
        } else {
            cutOffRefinements.push(refinementHTML);
        }
    }
    let showMoreSectionHTML = '';
    if (cutOffRefinements.length > 0) {
        showMoreSectionHTML = showMoreSection(refinement, cutOffRefinements);
    }
    return `
        <ul class="swatches ${refinement.baseID}">
            ${visibleRefinementItems.join('')}
            ${showMoreSectionHTML}
        </ul>
        <span role="link" tabindex="0" class="info-link width-info-link ${`${window.Constants.SITE_ID}-sizewidthtable fylin-link flyin-product-info-width`}"
            data-href="${window.Urls.WIDTH_INFO}" title="${window.Resources.WIDTH_INFORMATION}" target="_blank">
            <span>${window.Resources.WIDTH_INFORMATION}</span>
            <img class="plus-img" alt="${window.Resources.PLUS}" src="${window.Urls.PLUS_IMAGE}"/>
        </span>
    `;
};
